module.exports = __webpack_public_path__ + "static/media/desktop_instagram_video.100f8d5e.png";